export default function CsharpDefaultParameters() {
  return (
    <h2>Csharp Default Parameters</h2>
  );
}
